export const WIDTH = 'width';
export const QUANTITY = 'quantity';
export const EDGE_DETAIL = 'edge_detail';
export const SHEEN = 'sheen';
